import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";
import { ListSearchReqBody, MapQueryParams } from "./MapGateway";

interface PlaceQueryParams {
    mapid: string;
    XID: string;
}

interface PlaceAllQueryParams {
    mapid: string;
}

interface PlaceInfoQueryParams extends PlaceQueryParams {
    type: string;
}

interface PlaceInfoReqBody {
    [fieldKey: string]: any;
    geometry: number[];
    images?: File[];
    imageNames?: string[];
}

interface AllPlaceInfoReqBody {
    allXids: number[];
}

class PlaceGateway extends Gateway {
    protected readonly _contextPath = "map/place";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        list: "list",
        allinfo: "allinfo",
        info: "info",
        view: "view",
        count: "count",
        add: "add",
        update: "update",
        delete: "delete",
        owner: "owner",
    };

    public async reqUpdateViewCnt(param: PlaceQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.view,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqPlaceList(param: MapQueryParams, body?: ListSearchReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.list,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqAllPlaceInfo(param: PlaceAllQueryParams, body: AllPlaceInfoReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.allinfo,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqPlaceInfo(param: PlaceInfoQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.info,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqImageList(param: PlaceQueryParams, body?: ListSearchReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.list,
            ...param,
        };
        return await this.request(Method.POST, "image", queryParam, body);
    }

    public async reqPlaceCount(param: PlaceAllQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.count,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqAddPlaceInfo(param: PlaceAllQueryParams, body: FormData): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.add,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqUpdatePlaceInfo(param: PlaceQueryParams, body: FormData): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.update,
            ...param,
        };
        
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqDeletePlaceInfo(param: PlaceQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.delete,
            ...param,
        };
        
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqPlaceOwner(param: PlaceQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.owner,
            ...param,
        };
        
        return await this.request(Method.POST, undefined, queryParam);
    }
   
}

export { PlaceGateway, type PlaceQueryParams, type PlaceAllQueryParams, type PlaceInfoQueryParams, type PlaceInfoReqBody, type AllPlaceInfoReqBody };
